import { ReferralToCreate } from '@/fairplayer/domain/referral/ReferralToCreate';

export interface BackendReferralToCreate {
  fanEmail: string;
}

export const fromReferralToCreate = (referral: ReferralToCreate): BackendReferralToCreate => ({
  fanEmail: referral.fanEmail,
});
